import React, {useState} from "react";
import {Tabs} from "antd";
import styled from "styled-components";
import {AllCourierWalletsTab} from "./allCourierWalletsTab/AllCourierWalletsTab";

export const TabsContainer = styled(Tabs)`
    @media (max-width: 768px) {
        .ant-tabs-nav {
            display: flex;
            flex-direction: column;
        }
        .ant-tabs-nav-list {
            flex-direction: column;
        }
    }
`;

export const CourierWalletListPage = () => {
    const [activeTab, setActiveTab] = useState("allCourierWallets");

    return (
        <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
            <Tabs.TabPane tab="Tüm Kurye Cüzdanları" key="allCourierWallets">
                <AllCourierWalletsTab isTabOpened={activeTab === "allCourierWallets"} />
            </Tabs.TabPane>
        </TabsContainer>
    );
};
